import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';

/**
 * Renders an individual player link with optional reason and trailing comma.
 *
 * @param {object} props - Component props.
 * @param {object} props.playerItem - The raw player item containing player details and optional reason.
 * @param {string} props.prefix - Unique prefix for key generation.
 * @param {number} props.index - Index in the player array.
 * @param {number} props.total - Total number of players in the array.
 * @param {boolean} [props.isAFLW] - Whether the competition is AFLW.
 * @param {string|number} [props.clubId] - Club identifier.
 * @param {string} [props.context] - Team lineups context string.
 * @returns {React.JSX.Element} The rendered TAPlayerItem.
 */
export const TAPlayerItem = ({
    playerItem,
    prefix,
    index,
    total,
    isAFLW,
    clubId,
    context
}) => {
    const player = playerItem?.player;
    const playerId = playerItem?.playerId || player?.playerId;
    const givenName = player?.playerName?.givenName;
    const surname = player?.playerName?.surname;
    const key = `TAFieldInsOuts__${prefix}__${playerId ?? index}`;

    /* eslint-disable */
    const trackingInfo = {
        event: PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT.LINK,
        component_name:
            PULSE.app.common.CONSTANTS.TRACKING.VALUES.TEAM_LINEUPS.VIEW.FIELD,
        component_content_type:
            context === 'match-centre'
                ? PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES.MATCH_CENTRE
                      .LINEUPS
                : PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES.LINEUPS
    };
    /* eslint-enable */

    return (
        <Fragment key={key}>
            <PlayerProfileLink
                classes="team-announcements__link"
                player={{ playerId, firstName: givenName, surname }}
                trackingInfo={trackingInfo}
                isAFLW={isAFLW}
                clubId={clubId}
            >
                <span>
                    {givenName} {surname}
                </span>
            </PlayerProfileLink>
            <span>
                {playerItem?.reason ? ` (${playerItem.reason})` : null}
                {index + 1 !== total ? ', ' : ''}{' '}
            </span>
        </Fragment>
    );
};

TAPlayerItem.propTypes = {
    playerItem: PropTypes.shape({
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        reason: PropTypes.string,
        player: PropTypes.shape({
            playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            playerName: PropTypes.shape({
                givenName: PropTypes.string,
                surname: PropTypes.string
            })
        })
    }).isRequired,
    prefix: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    isAFLW: PropTypes.bool,
    clubId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    context: PropTypes.string
};
